let colorList = [
  '#00C5FA',
  '#0078FF',
  '#FCF5C2',
  '#58ECAC',
  '#FF8C60',
  '#A280FF',
  '#EE6566',
  '#FAC959',
  '#91CD74',
  '#3AA272',
  '#AAE6FF',
];
export default function drawLine(data, dom) {
  var fontColor = '#c0c0c0';
  let dimensions = [];
  for (let i in data.data[0]) {
    dimensions.push(i);
  }
  let series = [];
  data?.names.forEach((item, i) => {
    series.push({
      name: item,
      type: 'line',
      stack: '总量',
      showSymbol: false,
    });
  });
  let option = {
    dataset: {
      dimensions,
      source: data.data,
    },
    color: colorList,
    // backgroundColor: '#11183c',
    grid: {
      top: '10px',
      left: '50px',
      right: 10,
      // bottom: '20px',

      // containLabel: true,
    },
    tooltip: {
      show: true,
      trigger: 'axis',
      confine: true,
    },
    legend: {
      show: false,
      top: 20,
      right: 0,
      orient: 'vertical',
      // y: 'center',
      // icon: 'stack',
      // itemWidth: 10,
      // itemHeight: 10,
      itemStyle: {
        borderWidth: 8,
      },
      textStyle: {
        color: '#ddd',
      },
      // data: ['已采纳', '已发布']
    },
    xAxis: [
      {
        type: 'category',
        boundaryGap: false,
        axisLabel: {
          color: fontColor,
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: 'rgba(56, 89, 130, 0.26)',
          },
        },
        axisTick: {
          show: false,
        },
        // data: data.data.map((x) => x['年份']),
      },
    ],
    yAxis: [
      {
        type: 'value',
        name: '',
        // min: 0,
        // max: 1000,
        axisLabel: {
          formatter: '{value}',
          textStyle: {
            color: '#c0c0c0',
          },
        },
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: 'rgba(56, 89, 130, 0.26)',
          },
        },
      },
    ],
    series,
  };
  console.log(444, option);
  return option;
}
